import PersonalIcons from '@/icons/PersonIcons'
import IdentificationIcons from '@/icons/IDCardIcons'
import AddressIcons from '@/icons/AddressIcons'
import FinanceIcons from '@/icons/HeartIcons'
import ExperienceIcons from '@/icons/GraduationIcons'
import ProfileIcons from '@/icons/FileIcons'
import WorkIcons from '@/icons/BriefCaseIcons'
import { useTranslation } from 'react-i18next'
import TabComponents from './TabComponents'

export const useEmployeeUpdateTabs = ({
    employeeId,
    isSelf = false,
}: {
    employeeId?: number
    isSelf?: boolean
} = {}) => {
    const { t } = useTranslation()

    const commonProps = { employeeId, isSelf }

    const tabs = [
        {
            label: t('employees.personal'),
            value: '',
            startIcon: <PersonalIcons />,
            component: <TabComponents.Personal {...commonProps} />,
        },
        {
            label: t('employees.identification'),
            value: 'identification',
            startIcon: <IdentificationIcons />,
            component: <TabComponents.Identification {...commonProps} />,
        },
        {
            label: t('employees.address'),
            value: 'address',
            startIcon: <AddressIcons />,
            component: <TabComponents.Address {...commonProps} />,
        },
        {
            label: t('employees.finance'),
            value: 'finance',
            startIcon: <FinanceIcons />,
            component: <TabComponents.Finance {...commonProps} />,
        },
        {
            label: t('employees.experience'),
            value: 'experience',
            startIcon: <ExperienceIcons />,
            component: <TabComponents.Experience {...commonProps} />,
        },
        {
            label: t('employees.profile'),
            value: 'profile',
            startIcon: <ProfileIcons />,
            component: <TabComponents.Profile {...commonProps} />,
        },
        {
            label: t('employees.work-info'),
            value: 'work-info',
            startIcon: <WorkIcons />,
            component: <TabComponents.WorkInfo {...commonProps} />,
        },
    ]

    return tabs
}
